<syn-avatar
    matIco="folder-outline"
    [size]="size"
    [tooltip]="tooltip ? title : ''"
    [link]="clickable ? link : undefined"
    [text]="text"
    [caption]="caption"
    [backgroundColor]="backgroundColor"
    [iconColor]="iconColor"
></syn-avatar>
